import 'izitoast/dist/css/iziToast.min.css';

import toastr, { IziToastSettings } from 'izitoast';

import { ToastType } from './tost-type.enum';

/**
 * Classe responsável por criação de toasts
 */
class Toast {
  /**
   * Mensagem a ser exibida
   *
   * @param message
   */
  constructor(private message: string, private type: ToastType, private options?: IziToastSettings) {}

  /**
   * Método responsável por exibir a mensagem
   */
  public show() {
    toastr[this.type]({ message: this.message, position: 'topRight', ...(this.options || {}) });
  }
}

export default Toast;
